export type UserNotification = {
    id: string;
    title: string;
    message?: string;
    read: boolean;
    sourceSystem: SourceSystemType;
    sourceId?: string;
    updatedAt: string;
};
export type UserRegistrationRequest = {
    language: string;
};

export enum SourceSystemType {
    Contentful = "CONTENTFUL",
}

export const registerPath = "/register/user";
